__turbopack_context__.v({
  "channel": "LiveTVRow-module-scss-module__ZgtiYa__channel",
  "livetv_row": "LiveTVRow-module-scss-module__ZgtiYa__livetv_row",
  "livetv_row__loading": "LiveTVRow-module-scss-module__ZgtiYa__livetv_row__loading",
  "livetv_row__splide_arrow": "LiveTVRow-module-scss-module__ZgtiYa__livetv_row__splide_arrow",
  "livetv_row_title": "LiveTVRow-module-scss-module__ZgtiYa__livetv_row_title",
});
